// extracted by mini-css-extract-plugin
export default {"list":"MyShoplistsData_list__OWbQy","dark":"MyShoplistsData_dark__KUqJo","itemSubInfo":"MyShoplistsData_itemSubInfo__-OP8y"};